export default {
  title: 'Product Material Data',
  description: 'Manage product master data, material information, and BOM relationships from the MDM system.',
  sync: {
    title: 'Data Sync Status',
    normal: 'Normal',
    syncing: 'Syncing',
    error: 'Error',
    lastSyncTime: 'Last Sync: {time}',
    productCount: 'Products: {count}',
    materialCount: 'Materials: {count}'
  },
  tabs: {
    product: 'Product Data',
    material: 'Material Data'
  },
  filter: {
    productTitle: 'Product Filters',
    materialTitle: 'Material Filters',
    scheme: 'Scheme:',
    defaultScheme: 'Default',
    recentScheme: 'Recent',
    search: 'Search',
    reset: 'Reset',
    conditions: 'Conditions',
    save: 'Save',
    expand: 'Expand',
    collapse: 'Collapse',
    contains: 'Contains',
    equals: 'Equals',
    productConditionTitle: 'Product Filter Conditions',
    materialConditionTitle: 'Material Filter Conditions'
  },
  actions: {
    detail: 'Detail',
    attrDetail: 'Attributes',
    bomQuery: 'BOM',
    query: 'Query',
    recordsCount: '{count} records'
  },
  status: {
    active: 'Active',
    inactive: 'Inactive',
    latest: 'Latest',
    history: 'History'
  },
  fields: {
    productCode: 'Product Code',
    productName: 'Product Name',
    prodLine: 'Product Line',
    brandName: 'Brand',
    prodCategoryName: 'Category',
    prodTypeName: 'Type',
    prodModel: 'Model',
    color: 'Color',
    weight: 'Weight(kg)',
    validFrom: 'Valid From',
    validTo: 'Valid To',
    status: 'Status',
    itemCode: 'Material Code',
    itemName: 'Material Name',
    itemType: 'Material Type',
    unit: 'Unit',
    materialGroup: 'Material Group',
    baseUnit: 'Base Unit',
    materialStatus: 'Material Status',
    operation: 'Operation',
    parentItemCode: 'Parent Code',
    parentItemName: 'Parent Name',
    childItemCode: 'Child Code',
    childItemName: 'Child Name',
    bomQty: 'Qty',
    bomUnit: 'Unit',
    bomLevel: 'Level',
    parentVersion: 'Parent Version',
    childVersion: 'Child Version',
    isLatest: 'Latest'
  },
  detailFields: {
    categoryName: 'Category',
    brandName: 'Brand',
    productName: 'Product Name',
    productModel: 'Model',
    bareCode: 'Bare Unit Code',
    upcCode: 'UPC',
    eanCode: 'EAN',
    productColor: 'Color',
    singlePackageLength: 'Single Package Length',
    headsetBatteryWeightG: 'Headset Battery Weight/g',
    certificationTransportReport: 'Product Certification + Transport Report',
    caseBatteryWeightG: 'Case Battery Weight/g',
    wirelessTransmissionType: 'Wireless Transmission Type',
    bluetoothName: 'Bluetooth Name',
    productWeightG: 'Product Weight/g',
    batteryLifeH: 'Battery Life/h',
    chargingTimeMin: 'Charging Time/min',
    chargingVoltage: 'Charging Voltage',
    chargingMethod: 'Charging Method',
    standbyTime: 'Standby Time',
    dustWaterproofLevel: 'Dust/Waterproof Rating',
    bluetoothChip: 'Bluetooth Chip',
    bluetoothVersion: 'Bluetooth Version',
    bluetoothFrequencyRange: 'Bluetooth Frequency Range',
    bluetoothCodecFormat: 'Bluetooth Codec Format',
    bluetoothConnectionDistance: 'Bluetooth Connection Distance',
    maxRfOutputPower: 'Max RF Output Power',
    productSize: 'Product Size',
    eqType: 'EQ Type',
    earphoneCoreTech: 'Earphone Core Technology',
    micTech: 'MIC Technology',
    speakerImpedance: 'Speaker Impedance',
    manufacturingRegion: 'Manufacturing Region',
    warrantyPeriod: 'Warranty Period',
    material: 'Material',
    function: 'Function',
    speakerType: 'Speaker Type',
    frequencyResponse: 'Frequency Response',
    speakerSensitivity: 'Speaker Sensitivity',
    microphoneSensitivity: 'Microphone Sensitivity',
    compatibleProfiles: 'Compatible Profiles',
    frequencyBand: 'Frequency Band',
    fastCharging: 'Fast Charging',
    supportedAudioCodecs: 'Supported Audio Codecs',
    singlePackageWidth: 'Single Package Width',
    singlePackageHeight: 'Single Package Height',
    singlePackageVolume: 'Single Package Volume',
    singlePackageNetWeight: 'Single Package Net Weight',
    singlePackageGrossWeight: 'Single Package Gross Weight',
    outerBoxLength: 'Outer Box Length',
    outerBoxWidth: 'Outer Box Width',
    outerBoxHeight: 'Outer Box Height',
    outerBoxVolume: 'Outer Box Volume',
    outerBoxNetWeight: 'Outer Box Net Weight',
    outerBoxGrossWeight: 'Outer Box Gross Weight',
    innerBoxQuantity: 'Inner Box Quantity',
    innerBoxSize: 'Inner Box Size',
    packagingMaterial: 'Packaging Material',
    chargingCableType: 'Charging Cable Type',
    chargingCableLength: 'Charging Cable Length',
    chargingCableMaterial: 'Charging Cable Material',
    packingList: 'Packing List',
    caseBatteryVolumeCm3: 'Case Battery Volume/cm³',
    headsetBatteryCapacityWhMah: 'Headset Battery Capacity/Wh-mAh',
    headsetLithiumContentMg: 'Headset Lithium Content/mg',
    headsetBatteryVolumeCm3: 'Headset Battery Volume/cm³',
    headsetBatteryType: 'Headset Battery Type',
    headsetBatterySize: 'Headset Battery Size',
    headsetBatteryQuantity: 'Headset Battery Quantity',
    headsetMaxCycleCount: 'Headset Max Cycle Count',
    caseLithiumContentMg: 'Case Lithium Content/mg',
    caseBatteryType: 'Case Battery Type',
    caseBatterySize: 'Case Battery Size',
    caseBatteryQuantity: 'Case Battery Quantity',
    caseMaxCycleCount: 'Case Max Cycle Count',
    caseBatteryCapacityWhMah: 'Case Battery Capacity/Wh-mAh',
    batteryCertificationTransportReport: 'Battery Certification + Transport Report',
    waterproofTestCondition: 'Waterproof Test Condition',
    batteryLifeTestCondition: 'Battery Life Test Condition',
    fastChargeTest: 'Fast Charge Test',
    materialName: 'Material Name',
    productType: 'Product Type',
    shortName: 'Short Name',
    mainUnit: 'Main Unit',
    bigCategory: 'Major Category',
    specifications: 'Specifications',
    createdDate: 'Created Date',
    upDownPassage: 'Up/Down Channel',
    version: 'Version',
    firstCategory: 'Level 1 Category',
    secondCategory: 'Level 2 Category',
    thirdCategory: 'Level 3 Category',
    fourthCategory: 'Level 4 Category',
    managementCategory: 'Management Category',
    customsNo: 'Customs No.',
    customsDeclarationName: 'Customs Declaration Name',
    englishName: 'English Name',
    chineseCustomsNo: 'Chinese Customs No.',
    declarationBrand: 'Brand (Declaration)',
    customsModel: 'Customs Model',
    areaOrigin: 'Area/Origin',
    netWeight: 'Net Weight',
    originArea: 'Origin Area',
    specialAttributes: 'Special Attributes',
    euUkHsCode: 'EU/UK HS Code',
    jpnHsCode: 'Japan HS Code',
    caHsCode: 'Canada HS Code',
    usHtsCode: 'US HTS Code',
    krHsCode: 'Korea HS Code',
    htsCode: 'Generic HS Code',
    logisticsBrand: 'Brand (Logistics)',
    majorCategoryDropdown: 'Major Category Dropdown',
    newErpCategory: 'New ERP Category',
    boxLong: 'Outer Box Length',
    boxWidth: 'Outer Box Width',
    boxHeight: 'Outer Box Height',
    boxWeight: 'Outer Box Weight',
    boxGauge: 'Outer Box Specification',
    barCode: 'UPC Barcode',
    warehouseBrand: 'Brand',
    brandNameText: 'Brand Name'
  },
  placeholder: {
    productCode: 'Enter product code',
    productName: 'Enter product name',
    prodLine: 'Select product line',
    brandName: 'Enter brand',
    prodCategoryName: 'Enter category',
    prodTypeName: 'Enter type',
    prodModel: 'Enter model',
    color: 'Enter color',
    weight: 'Enter weight',
    validFrom: 'Enter valid from',
    validTo: 'Enter valid to',
    status: 'Select status',
    itemCode: 'Enter material code',
    itemName: 'Enter material name',
    itemType: 'Select material type',
    unit: 'Enter unit',
    materialGroup: 'Enter material group',
    baseUnit: 'Enter base unit',
    materialStatus: 'Enter material status',
    parentItemCode: 'Enter parent material code',
    childItemCode: 'Enter child material code'
  },
  modal: {
    productDetail: 'Product Detail',
    materialDetail: 'Material Attribute Detail',
    bomTitle: 'BOM Structure Query',
    noBomData: 'No BOM data',
    levelTitle: 'L{level}',
    levelCount: '{count} records',
    productInfo: 'Product Info ',
    productDetailInfo: 'Product Detail ',
    materialBasic: 'Basic Attributes ',
    materialCategory: 'Category Attributes ',
    materialLogistics: 'Logistics Attributes ',
    materialWarehouse: 'Warehouse Attributes '
  },
  options: {
    openrun: 'OpenRun Series',
    openmove: 'OpenMove Series',
    opencomm: 'OpenComm Series',
    other: 'Other',
    raw: 'Raw Material',
    semi: 'Semi-finished',
    finished: 'Finished Goods',
    packaging: 'Packaging Material'
  }
}
